// extracted by mini-css-extract-plugin
export var fullHeightState = "_41-7";
export var headerCell = "_41-1";
export var loadingStateCell = "_41-4";
export var rowWrapper = "_41-3";
export var standaloneTable = "_41-8";
export var standaloneTableWithBodyFill = "_41-9";
export var stateCell = "_41-5";
export var table = "_41-0";
export var tableBodyFiller = "_41-6";
export var white = "_41-2";